<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="StarIcon" @click="goReview" svgClasses="h-6 w-6 mr-5 hover:text-warning cursor-pointer" />
      <feather-icon icon="EyeIcon" v-if="activeUserInfo.role == 'doctor'" @click="goConsultation" svgClasses="h-6 w-6 mr-5 hover:text-primary cursor-pointer" />
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    goReview(data){
      console.log(data);
      window.open('/links/consultation-review/'+this.params.data.id, '_blank');
    },
    goConsultation(data){
      console.log(data);
      window.open('/consultations/newConsultation/?consultationId='+this.params.data.id, '_blank');
    },
  }
}
</script>
